import { restClient } from '../../client';


export type OutOfOfficeEvent = {
  id: string;
  eventTitle: string;
  startDate: string;
  endDate: string;
};


export type CreateOutOfOfficeEventBody = {
  eventTitle: string;
  startDate: string;
  endDate: string;
};

export type UpdateOutOfOfficeEventBody = {
  eventTitle?: string;
  startDate?: string;
  endDate?: string;
};

export const getOutOfOfficeEvents = (providerId: string) =>
  restClient.request<{ data: OutOfOfficeEvent[] }>(`/api/v1/providers/${providerId}/out_of_office`);

export const createOutOfOfficeEvent = (providerId: string, body: CreateOutOfOfficeEventBody) =>
  restClient.request<OutOfOfficeEvent>(`/api/v1/providers/${providerId}/out_of_office`, {
    method: 'POST',
    data: { event_title: body.eventTitle, start_date: body.startDate, end_date: body.endDate },
  });

export const deleteOutOfOfficeEvent = (providerId: string, outOfOfficeId: string) =>
  restClient.request(`/api/v1/providers/${providerId}/out_of_office/${outOfOfficeId}`, {
    method: 'DELETE',
  });

export const updateOutOfOfficeEvent = (providerId: string, outOfOfficeId: string, body: UpdateOutOfOfficeEventBody) =>
  restClient.request<OutOfOfficeEvent>(`/api/v1/providers/${providerId}/out_of_office/${outOfOfficeId}`, {
    method: 'PUT',
    data: { event_title: body.eventTitle, start_date: body.startDate, end_date: body.endDate },
  });

export const getActiveOutOfOffice = (providerId: string) =>
  restClient.request<{ data: OutOfOfficeEvent | null }>(`/api/v1/client/providers/${providerId}/out_of_office/current`);
